import React, { useState } from "react";
import "./event-card.css";
import { events } from "../../constants/data";
import { Link } from "react-router-dom";

const EventCard = () => {
  const [itemOffset, setItemOffset] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const eventsPerPage = 10;

  const endOffset = itemOffset + eventsPerPage;
  const currentEvents = events.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(events.length / eventsPerPage);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * eventsPerPage) % events.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      <section className="eventCard">
        <div className="header">
          <h3>past events</h3>
        </div>
        <div className="cardsWrapper">
          {events &&
            currentEvents
              .filter((event_name) =>
                event_name.title
                  .toLowerCase()
                  .includes(searchQuery.toLowerCase())
              )
              .map((event) => (
                <Link to={`/events/${event.id}`} key={event.id}>
                  <div className="card">
                    <div className="date">
                      <div className="day">{event.date.day}</div>
                      <small className="month">{event.date.month}</small>
                      <div className="year">{event.date.year}</div>
                    </div>
                    <div className="info">
                      <div className="image">
                        <img
                          src={event.image}
                          alt={event.title}
                          loading="lazy"
                        />
                      </div>
                      <div className="details">
                        <div className="title">
                          <h2>{event.title}</h2>
                        </div>
                        <div className="location">
                          <p>{event.location}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
        </div>
      </section>
    </>
  );
};

export default EventCard;
